import React, { useState } from "react";

const EMAIL = "expressrouteslogisticusa@gmail.com";
const PHONE = "(702) 888-0772";

const galleryImages = [
  "/gallery/van-front.jpeg",
  "/gallery/van-side.jpeg",
  "/gallery/load-1.jpeg",
  "/gallery/load-2.jpeg",
  "/gallery/load-3.jpeg",
  "/gallery/load-4.jpeg",
  "/gallery/load-5.jpeg",
  "/gallery/load-6.jpeg",
];

function InterstateMap() {
  const hubs = [
    { x: 150, y: 285, label: "West", color: "#22c55e" },
    { x: 430, y: 365, label: "South / Central", color: "#2563eb" },
    { x: 600, y: 235, label: "Midwest", color: "#2563eb" },
    { x: 720, y: 320, label: "Southeast", color: "#2563eb" },
    { x: 820, y: 225, label: "Northeast", color: "#2563eb" },
    { x: 185, y: 450, label: "Alaska", color: "#f59e0b" },
  ];

  return (
    <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 sm:pb-20">
      <style>{`
        @keyframes routeFlow {
          from { stroke-dashoffset: 160; }
          to { stroke-dashoffset: 0; }
        }

        @keyframes hubPulse {
          0%, 100% { opacity: 0.18; transform: scale(1); }
          50% { opacity: 0.55; transform: scale(1.25); }
        }

        @keyframes trackingMove {
          0% { offset-distance: 0%; }
          18% { offset-distance: 22%; }
          35% { offset-distance: 45%; }
          52% { offset-distance: 68%; }
          70% { offset-distance: 86%; }
          100% { offset-distance: 100%; }
        }

        @keyframes blinkDot {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
            filter: drop-shadow(0 0 10px #38bdf8);
          }
          50% {
            opacity: 0.35;
            transform: scale(1.45);
            filter: drop-shadow(0 0 24px #60a5fa);
          }
        }

        @keyframes outerPing {
          0% {
            opacity: 0.75;
            transform: scale(0.7);
          }
          100% {
            opacity: 0;
            transform: scale(2.4);
          }
        }

        .moving-route {
          stroke-dasharray: 16 16;
          animation: routeFlow 3s linear infinite;
        }

        .hub-pulse {
          animation: hubPulse 2.2s ease-in-out infinite;
          transform-box: fill-box;
          transform-origin: center;
        }

        .tracking-dot {
          offset-path: path("M150 285 L430 365 L720 320 L820 225 L600 235 L150 285");
          animation: trackingMove 12s ease-in-out infinite;
          transform-box: fill-box;
          transform-origin: center;
        }

        .dot-core {
          animation: blinkDot 1s ease-in-out infinite;
          transform-box: fill-box;
          transform-origin: center;
        }

        .dot-ping {
          animation: outerPing 1.4s ease-out infinite;
          transform-box: fill-box;
          transform-origin: center;
        }
      `}</style>

      <div className="relative overflow-hidden rounded-[34px] border border-slate-700 bg-[#071122] p-5 shadow-2xl sm:p-7">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.04)_1px,transparent_1px)] bg-[size:64px_64px]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(37,99,235,.18),transparent_45%)]" />

        <div className="relative z-10 mb-6 flex flex-col justify-between gap-4 md:flex-row">
          <div>
            <h3 className="text-xl font-black uppercase tracking-wide text-white sm:text-2xl">
              Advanced Nationwide Cargo Network
            </h3>

            <p className="text-sm text-slate-400 sm:text-base">
              Real-time interstate freight corridors for Sprinter van and cargo
              van logistics
            </p>
          </div>

          <div className="flex items-center gap-2 text-sm text-slate-300 sm:text-base">
            <span className="rounded-full bg-blue-600 px-2 text-white">✓</span>
            Live Route Intelligence
          </div>
        </div>

        <div className="relative z-10 h-[380px] sm:h-[480px] md:h-[580px]">
          <svg viewBox="0 0 1000 520" className="h-full w-full">
            <path
              d="M150 105 L270 115 L395 115 L445 130 L485 140 L530 128 L570 136 L610 158 L660 160 L710 150 L770 165 L830 145 L900 135 L960 100"
              fill="none"
              stroke="#334155"
              strokeWidth="4"
              opacity="0.75"
            />

            <path
              d="M150 105 L135 250 L150 340 L205 395 L275 410 L335 455 L410 500 L455 490 L485 450 L500 395 L545 345 L640 345 L705 360 L765 340 L805 365 L835 410 L850 470"
              fill="none"
              stroke="#334155"
              strokeWidth="4"
              opacity="0.75"
            />

            <path
              className="moving-route"
              d="M150 285 L430 365 L720 320 L820 225 L600 235 L150 285"
              fill="none"
              stroke="#3b82f6"
              strokeWidth="6"
              opacity="0.95"
            />

            <path
              className="moving-route"
              d="M150 285 L600 235 L820 225"
              fill="none"
              stroke="#60a5fa"
              strokeWidth="4"
              opacity="0.65"
            />

            <path
              className="moving-route"
              d="M820 225 L720 320"
              fill="none"
              stroke="#60a5fa"
              strokeWidth="4"
              opacity="0.65"
            />

            {hubs.map((hub) => (
              <g key={hub.label}>
                <circle
                  className="hub-pulse"
                  cx={hub.x}
                  cy={hub.y}
                  r="34"
                  fill={hub.color}
                />

                <circle cx={hub.x} cy={hub.y} r="11" fill={hub.color} />

                <text
                  x={hub.x}
                  y={hub.y - 30}
                  textAnchor="middle"
                  fill="#dbeafe"
                  fontSize="17"
                  fontWeight="800"
                >
                  {hub.label}
                </text>
              </g>
            ))}

            <g className="tracking-dot">
              <circle
                className="dot-ping"
                cx="0"
                cy="0"
                r="18"
                fill="#38bdf8"
              />

              <circle
                cx="0"
                cy="0"
                r="17"
                fill="#020617"
                stroke="#38bdf8"
                strokeWidth="3"
                opacity="0.95"
              />

              <circle className="dot-core" cx="0" cy="0" r="9" fill="#60a5fa" />
            </g>
          </svg>
        </div>
      </div>
    </section>
  );
}

export default function App() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
  });

  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState("");

  const handleChange = (e) =>
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus("");

    try {
      const res = await fetch("/api/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error("Email failed");

      setStatus("success");

      setForm({
        name: "",
        email: "",
        company: "",
        message: "",
      });
    } catch {
      setStatus("error");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen overflow-x-hidden bg-sky-50 text-neutral-900">
      <style>{`
        html { scroll-behavior: smooth; }
        body { overflow-x: hidden; }

        @keyframes flagWave {
          0% { transform: rotate(0deg) skewX(0deg); }
          25% { transform: rotate(2deg) skewX(-4deg); }
          50% { transform: rotate(0deg) skewX(0deg); }
          75% { transform: rotate(-2deg) skewX(4deg); }
          100% { transform: rotate(0deg) skewX(0deg); }
        }

        .flag-wave {
          animation: flagWave 1.5s ease-in-out infinite;
          transform-origin: left center;
        }

        .logo-hover {
          transition: transform .35s ease, box-shadow .35s ease;
          transform-origin: center;
          position: relative;
        }

        .logo-hover:hover {
          transform: scale(1.8);
          z-index: 9999;
          box-shadow: 0 25px 60px rgba(15,23,42,.35);
        }

        @media (min-width:768px){
          .logo-hover:hover {
            transform:scale(2.5);
          }
        }
      `}</style>

      <header className="sticky top-0 z-50 border-b bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-4 sm:px-6 lg:grid lg:grid-cols-3 lg:items-center">
          <div className="flex items-center justify-center gap-3 lg:justify-start">
            <img
              src="/logo.png"
              alt="ExpressRoutesLogisticsUSA"
              className="logo-hover h-16 w-auto rounded-2xl bg-white p-2 shadow-xl object-contain sm:h-20 lg:h-24"
            />

            <div className="min-w-0 leading-tight">
              <h1 className="break-words text-lg font-black text-slate-950 sm:text-xl lg:text-2xl">
                ExpressRoutesLogisticsUSA
              </h1>

              <p className="text-xs uppercase tracking-[0.25em] text-neutral-500 sm:text-sm sm:tracking-[0.3em]">
                Logistics USA
              </p>
            </div>
          </div>

          <div className="flex justify-center">
            <div className="rounded-full bg-white px-4 py-2 shadow-xl sm:px-5 sm:py-3">
              <img
                src="/flag.png"
                alt="United States Flag"
                className="flag-wave h-7 w-auto object-contain sm:h-9 lg:h-10"
              />
            </div>
          </div>

          <nav className="flex flex-wrap items-center justify-center gap-2 text-xs font-semibold sm:gap-4 sm:text-sm lg:justify-end">
            <a href="#about" className="rounded-full px-3 py-2 hover:bg-sky-100">
              About
            </a>

            <a href="#services" className="rounded-full px-3 py-2 hover:bg-sky-100">
              Services
            </a>

            <a href="#coverage" className="rounded-full px-3 py-2 hover:bg-sky-100">
              Coverage
            </a>

            <a href="#gallery" className="rounded-full px-3 py-2 hover:bg-sky-100">
              Gallery
            </a>

            <a
              href="#contact"
              className="rounded-full bg-slate-950 px-5 py-2 text-white shadow-xl hover:bg-black"
            >
              Contact
            </a>
          </nav>
        </div>
      </header>

      <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-14">
        <div className="rounded-[28px] bg-white/80 p-6 shadow-xl sm:rounded-[32px] sm:p-8 md:p-10">
          <div className="inline-flex max-w-full items-center gap-3 rounded-full border bg-white px-4 py-2 text-xs font-semibold uppercase tracking-wide text-emerald-800 shadow sm:text-sm">
            <span className="h-4 w-4 shrink-0 rounded-full bg-emerald-400 ring-4 ring-emerald-100" />
            <span>Book Today — Open To Take New Loads</span>
          </div>

          <h1 className="mt-8 max-w-4xl text-4xl font-bold leading-tight text-slate-950 sm:text-5xl md:text-6xl lg:text-7xl">
            Coast-to-coast coverage for cargo vans &amp; final-mile
          </h1>

          <p className="mt-6 max-w-3xl text-lg leading-relaxed text-neutral-600 sm:text-xl">
            Expedited hot shots, dedicated lanes, and white-glove final mile —
            powered by a vetted nationwide Sprinter and cargo van network.
          </p>

          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
            <a
              href="#contact"
              className="rounded-full bg-slate-950 px-7 py-3 text-center font-semibold text-white shadow-xl transition hover:bg-black"
            >
              Get a Quote
            </a>

            <a
              href="#contact"
              className="rounded-full border bg-white px-7 py-3 text-center font-semibold text-slate-950 shadow transition hover:bg-neutral-100"
            >
              Talk to Dispatch
            </a>
          </div>
        </div>
      </section>

      <section id="about" className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 sm:pb-20">
        <h2 className="text-4xl font-bold sm:text-5xl">
          About Our Sprinter Cargo Van
        </h2>

        <p className="mt-4 max-w-5xl text-xl leading-relaxed text-neutral-600 sm:text-2xl">
          2019 Mercedes-Benz Sprinter 2500 High Roof Extended Cargo Van.
        </p>

        <div className="mt-10 rounded-[28px] bg-white p-6 shadow-xl sm:rounded-[32px] sm:p-8">
          <p className="text-base leading-relaxed text-neutral-700 sm:text-lg">
            Vehicle is equipped for expedited cargo transportation and offers
            approximately:
          </p>

          <div className="mt-8 grid gap-6 md:grid-cols-2 md:gap-8">
            <div className="rounded-3xl bg-sky-50 p-5 sm:p-6">
              <ul className="space-y-4 text-base leading-relaxed text-neutral-700 sm:text-lg">
                <li>
                  • <strong>170” extended wheelbase</strong>
                </li>
                <li>
                  • <strong>Up to 13.5 ft cargo length</strong>
                </li>
                <li>
                  • <strong>Around 6’3” interior standing height</strong>
                </li>
                <li>
                  • Cargo capacity suitable for up to <strong>3,000 lbs</strong>{" "}
                  depending on freight dimensions and distribution
                </li>
                <li>
                  • Capable of handling palletized freight, medical equipment,
                  automotive parts, boxed freight, and expedited shipments
                </li>
              </ul>
            </div>

            <div className="rounded-3xl bg-sky-50 p-5 sm:p-6">
              <h3 className="mb-5 text-xl font-bold sm:text-2xl">
                Typical Cargo Area Dimensions
              </h3>

              <ul className="space-y-4 text-base leading-relaxed text-neutral-700 sm:text-lg">
                <li>
                  • <strong>Length:</strong> approx. 170–173 inches
                </li>
                <li>
                  • <strong>Width:</strong> approx. 70 inches
                </li>
                <li>
                  • <strong>Height:</strong> approx. 76 inches
                </li>
              </ul>

              <div className="mt-8 rounded-2xl bg-white p-5 shadow">
                <p className="text-base leading-relaxed text-neutral-700 sm:text-lg">
                  Vehicle is maintained for long-distance expedited
                  transportation and available for direct deliveries, dedicated
                  runs, and time-sensitive freight.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 sm:pb-20">
        <h2 className="text-4xl font-bold sm:text-5xl">Services</h2>

        <p className="mt-4 text-xl text-neutral-600 sm:text-2xl">
          Expedited freight • Dedicated routes • Scheduled runs • White-glove
          delivery.
        </p>

        <div className="mt-10 grid gap-6 md:grid-cols-3 md:gap-8">
          <div className="rounded-[28px] bg-white p-6 shadow-xl sm:rounded-[32px] sm:p-8">
            <h3 className="text-2xl font-bold sm:text-3xl">
              Expedited / Hot Shot
            </h3>

            <p className="mt-5 text-base leading-relaxed text-neutral-600 sm:text-lg">
              Time-critical cargo van moves with 24/7 dispatch and live tracking
              updates.
            </p>
          </div>

          <div className="rounded-[28px] bg-white p-6 shadow-xl sm:rounded-[32px] sm:p-8">
            <h3 className="text-2xl font-bold sm:text-3xl">
              Dedicated Lanes
            </h3>

            <p className="mt-5 text-base leading-relaxed text-neutral-600 sm:text-lg">
              Recurring lanes and route coverage for regional and national
              programs.
            </p>
          </div>

          <div className="rounded-[28px] bg-white p-6 shadow-xl sm:rounded-[32px] sm:p-8">
            <h3 className="text-2xl font-bold sm:text-3xl">White-Glove</h3>

            <p className="mt-5 text-base leading-relaxed text-neutral-600 sm:text-lg">
              Inside delivery, room-of-choice, and POD visibility with
              professional driver teams.
            </p>
          </div>
        </div>
      </section>

      <section id="coverage" className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 sm:pb-20">
        <h2 className="text-4xl font-bold sm:text-5xl">Coverage</h2>

        <p className="mt-4 text-xl text-neutral-600 sm:text-2xl">
          Headquartered in Miami—serving all 50 states with a focus on major
          cargo hubs.
        </p>

        <div className="mt-10 rounded-[28px] bg-white p-6 shadow-xl sm:rounded-[32px] sm:p-8">
          <p className="mb-10 text-lg text-neutral-700 sm:text-xl">
            Reliable capacity across the entire U.S. — from local final-mile in
            Florida to cross-country Sprinter moves.
          </p>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            <div>
              <h3 className="mb-3 text-lg font-bold uppercase text-neutral-600 sm:text-xl">
                Southeast
              </h3>
              <p className="text-base font-semibold sm:text-lg">
                FL, GA, AL, SC, NC, TN, MS, LA, AR, KY, WV
              </p>
            </div>

            <div>
              <h3 className="mb-3 text-lg font-bold uppercase text-neutral-600 sm:text-xl">
                Northeast
              </h3>
              <p className="text-base font-semibold sm:text-lg">
                NY, NJ, PA, MA, CT, RI, NH, VT, ME, MD, DE, DC
              </p>
            </div>

            <div>
              <h3 className="mb-3 text-lg font-bold uppercase text-neutral-600 sm:text-xl">
                Midwest
              </h3>
              <p className="text-base font-semibold sm:text-lg">
                IL, OH, MI, IN, WI, MN, IA, MO, KS, NE, SD, ND
              </p>
            </div>

            <div>
              <h3 className="mb-3 text-lg font-bold uppercase text-neutral-600 sm:text-xl">
                South / Central
              </h3>
              <p className="text-base font-semibold sm:text-lg">
                TX, OK, NM, CO, AZ
              </p>
            </div>

            <div>
              <h3 className="mb-3 text-lg font-bold uppercase text-neutral-600 sm:text-xl">
                West
              </h3>
              <p className="text-base font-semibold sm:text-lg">
                CA, WA, OR, NV, UT, ID, MT, WY
              </p>
            </div>

            <div>
              <h3 className="mb-3 text-lg font-bold uppercase text-neutral-600 sm:text-xl">
                Alaska
              </h3>
              <p className="text-base font-semibold sm:text-lg">AK</p>
            </div>
          </div>
        </div>
      </section>

      <InterstateMap />

      <section id="gallery" className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 sm:pb-20">
        <h2 className="text-4xl font-bold sm:text-5xl">Freight Gallery</h2>

        <p className="mt-4 text-xl text-neutral-600 sm:text-2xl">
          Real cargo van, freight, pallet, and delivery photos.
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
          {galleryImages.map((img, index) => (
            <div
              key={img}
              className="overflow-hidden rounded-[24px] bg-white shadow-xl sm:rounded-[28px]"
            >
              <img
                src={img}
                alt={`ExpressRoutesLogisticsUSA gallery ${index + 1}`}
                className="h-[260px] w-full object-cover transition duration-500 hover:scale-110 sm:h-[320px] lg:h-[340px]"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </section>

      <section id="contact" className="border-t bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 className="text-center text-4xl font-bold sm:text-5xl">
            Contact Dispatch
          </h2>

          <p className="mx-auto mt-6 max-w-3xl text-center text-lg text-neutral-600 sm:text-xl">
            Ready for a shipment? Send your load details and our dispatch team
            will follow up quickly.
          </p>

          <form
            onSubmit={handleSubmit}
            className="mx-auto mt-10 max-w-4xl rounded-[28px] bg-white p-5 shadow-2xl sm:mt-12 sm:rounded-[32px] sm:p-8"
          >
            <h3 className="text-2xl font-bold">Send load details</h3>

            <p className="mt-4 text-sm text-neutral-600 sm:text-base">
              Share your lane, pickup window, and special handling.
            </p>

            <div className="mt-6 grid gap-4 md:grid-cols-2">
              <input
                required
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
                className="w-full rounded-2xl border px-5 py-4 text-base"
              />

              <input
                required
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email"
                className="w-full rounded-2xl border px-5 py-4 text-base"
              />
            </div>

            <input
              name="company"
              value={form.company}
              onChange={handleChange}
              placeholder="Company (optional)"
              className="mt-4 w-full rounded-2xl border px-5 py-4 text-base"
            />

            <textarea
              required
              name="message"
              value={form.message}
              onChange={handleChange}
              rows={5}
              placeholder="Example: Sprinter load from Miami, FL to Atlanta, GA. Pickup today before 3pm, 2 pallets, 1,200 lbs."
              className="mt-4 w-full rounded-2xl border px-5 py-4 text-base"
            />

            <button
              type="submit"
              disabled={sending}
              className="mt-6 w-full rounded-full bg-slate-950 px-8 py-4 font-semibold text-white shadow-xl transition hover:bg-black disabled:cursor-not-allowed disabled:opacity-60"
            >
              {sending ? "Sending..." : "Submit To Dispatch"}
            </button>

            {status === "success" && (
              <p className="mt-5 rounded-2xl bg-emerald-50 p-4 text-center font-semibold text-emerald-700">
                Your request was sent successfully. Dispatch will follow up.
              </p>
            )}

            {status === "error" && (
              <p className="mt-5 rounded-2xl bg-red-50 p-4 text-center font-semibold text-red-700">
                Something went wrong. Please call or email dispatch directly.
              </p>
            )}
          </form>

          <div className="mx-auto mt-10 flex max-w-full flex-col items-center justify-center gap-4 break-words text-center text-lg font-semibold sm:flex-row sm:flex-wrap sm:gap-6 sm:text-xl">
            <a href="tel:+17028880772">📞 {PHONE}</a>

            <a href={`mailto:${EMAIL}`} className="break-all">
              ✉ {EMAIL}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}